<template>
  <div class="closed-empty" :style="style">
    <i :class="icon" class="closed-empty-ico"/>
    <div v-if="title" class="closed-empty-title" :class="{'large-title':largeText}">{{ title }}</div>
    <div v-if="text" class="closed-empty-text" :class="{'large-text':largeText}">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'NoticePlaceholder',
  props: {
    icon: {
      type: String,
      default: 'pi pi-exclamation-triangle',
    },
    title: {
      type: String,
      default: null,
    },
    style: {
      type: String,
      default: '',
    },
   text: {
      type: String,
      default: null,
    },
    largeText: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style scoped>
.closed-empty {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 26px 10px 18px;
}

.closed-empty-ico {
  font-size: 1.4rem;
  opacity: .65;
}

.closed-empty-title {
  margin-top: 12px;
  opacity: .85;
  font-weight: 700;
}

.closed-empty-text {
  margin-top: 8px;
  opacity: .85;
  font-size: .95rem;
}

.large-title {
  font-size: 1.2rem
}
.large-text {
  font-size: 1rem
}
</style>